// @flow

import * as React from 'react'
import css from './index.css'
import {resolveCss} from '$util'

type Props = {
  loading: ?boolean,
  css?: {},
  children: React.Node,
  onSuccess: Function
}

type State = {
  finishing: boolean,
  awaiting: boolean
}

export class LoadingScreen extends React.Component<Props, State> {
  state = {finishing: false, awaiting: false}

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.loading && !nextProps.loading) {
      if (!nextProps.error) {
        this.handleLoadingChanges()
      }
    }
  }

  handleLoadingChanges = () => {
    // If the load fails, the error-prop might not be truthy at the same render
    // the loading-prop goes false. (eg. "async error"-action dispatched after the "end fetch"-action.)
    // Wait 10ms for the error-flag to get updated. (eg. in redux)

    // use "awaiting"-flag to fill up the 10ms gap when awaiting for the error-flag
    // to potentially activate
    this.setState({awaiting: true})
    setTimeout(() => {
      if (!this.props.error) {
        this.finishAnimation()
        this.setState({awaiting: false})
      } else {
        this.setState({awaiting: false})
      }
    }, 10)
  }

  finishAnimation = () => {
    this.setState({finishing: true})

    //allow the finishing-animation to play for 1 sec until
    setTimeout(() => {
      this.setState({finishing: false})
      this.props.onSuccess()
    }, 1000)
  }

  render() {
    const classes = resolveCss(css, this.props.css)
    const {state: {finishing, awaiting}, props: {loading, children}} = this

    return loading || finishing || awaiting ? (
      <div {...classes('container')}>
        <div {...classes('circle-loader', !loading && 'load-complete')}>
          <div {...classes('checkmark', loading && 'hide', 'draw')} />
        </div>
        <p>{loading ? 'Signing in' : 'Signed in!'}</p>
      </div>
    ) : (
      React.Children.only(children)
    )
  }
}

export default LoadingScreen



// WEBPACK FOOTER //
// ./src/common/components/LoadingScreen/index.js